import { useState } from 'react'

import { filterAvailableFonts, type ReaderFontChoice } from '../components/reader-fonts'

let cachedFonts: ReaderFontChoice[] | null = null

const detectFonts = (): ReaderFontChoice[] => {
  if (cachedFonts) return cachedFonts
  const ctx = document.createElement('canvas').getContext('2d')
  cachedFonts = filterAvailableFonts(ctx)
  return cachedFonts
}

/** 端末にインストールされている読書用フォントの選択肢（判定は初回のみ） */
export const useAvailableReaderFonts = (): ReaderFontChoice[] => {
  const [fonts] = useState(detectFonts)
  return fonts
}
